import * as actions from '../actions/MasterSetupPageActions';

const masterSetupPageState = {
  formLayout: null,
  entityName: null,
  searchName: null,
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  isLoading: false,
  redirect: false,
  masterSetupImport: {
    isModalOpen: false,
    importEntities: {},
  },
  manageRights: {},
};

export default (state = masterSetupPageState, action) => {
  switch (action.type) {
    case actions.MASTER_SETUP_PAGE_SET_PARAMETERS: {
      return {
        ...state,
        entityName: action.entityName,
        searchName: action.searchName,
        redirect: false,
      };
    }
    case actions.MASTER_SETUP_PAGE_OPEN_DELETE_MODAL: {
      return {
        ...state,
        isDeleteModalOpen: true,
      };
    }
    case actions.MASTER_SETUP_PAGE_CLOSE_DELETE_MODAL: {
      return {
        ...state,
        isDeleteModalOpen: false,
      };
    }
    case actions.MASTER_SETUP_PAGE_SAVE_RECORD:
    case actions.MASTER_SETUP_PAGE_DELETE_RECORD: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actions.MASTER_SETUP_PAGE_SAVE_RECORD_SUCCESS:
    case actions.MASTER_SETUP_PAGE_DELETE_RECORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        redirect: true,
      };
    case actions.MASTER_SETUP_PAGE_SAVE_RECORD_FAILURE:
    case actions.MASTER_SETUP_PAGE_DELETE_RECORD_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case actions.MASTER_SETUP_PAGE_SET_MANAGE_RIGHTS: {
      const { manageRights } = state;
      const { entityName, hasRight } = action.payload;

      return {
        ...state,
        manageRights: { ...manageRights, [entityName]: hasRight },
      };
    }

    default:
      return state;
  }
};
